import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { gerarLinkCadastro, buscarCampanhas } from '~/Services/Service';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';

function ModalLinkCadastro({ show, onHide, empreendimentos, corretores }) {
  const [empreendimentoSelecionado, setEmpreendimentoSelecionado] = useState(null);
  const [corretorSelecionado, setCorretorSelecionado] = useState(null);
  const [linkGerado, setLinkGerado] = useState('');
  const [loading, setLoading] = useState(false);

  const isCorretor = AuthStorage.isCorretor();

  const options = (empreendimentos.sort || [])
    .map(item => ({ value: item.codigo, label: item.descricao }));

  const optionsCorretores = (corretores || [])
    .map(item => ({ value: item.codigo, label: item.nome }));

  useEffect(() => {
    if (!show || options.length === 0) return;
    const fixo = options.find(o => o.value === 11426);
    if (fixo) {
      setEmpreendimentoSelecionado(fixo);
      return;
    }
    buscarCampanhas()
      .then(campanhas => {
        const ativa = campanhas.find(c => !c.data_finalizacao);
        if (!ativa) return;
        const match = options.find(o => o.value === ativa.codigo_familia);
        if (match) setEmpreendimentoSelecionado(match);
      })
      .catch(() => {});
  }, [show]);

  const handleGerar = async () => {
    if (!empreendimentoSelecionado) return;
    setLoading(true);
    try {
      const payload = { codigo_familia: empreendimentoSelecionado.value };
      if (!isCorretor && corretorSelecionado) {
        payload.codigo_corretor = corretorSelecionado.value;
      }
      const response = await gerarLinkCadastro(payload);
      setLinkGerado(response.link);
    } catch (error) {
      toast.error(error.message || 'Erro ao gerar link');
    } finally {
      setLoading(false);
    }
  };

  const handleCopiar = () => {
    navigator.clipboard.writeText(linkGerado).then(() => {
      toast.success('Link copiado!', { autoClose: 1500 });
      handleClose();
    });
  };

  const handleClose = () => {
    setEmpreendimentoSelecionado(null);
    setCorretorSelecionado(null);
    setLinkGerado('');
    setLoading(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Link de Cadastro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="mb-1">Empreendimento</label>
          <Select
            isSearchable
            options={options}
            value={empreendimentoSelecionado}
            onChange={option => {
              setEmpreendimentoSelecionado(option);
              setLinkGerado('');
            }}
            placeholder="Selecione um empreendimento"
            styles={customStyles}
            components={{ DropdownIndicator }}
          />
        </div>
        {!isCorretor && (
          <div className="mb-3">
            <label className="mb-1">Corretor</label>
            <Select
              isSearchable
              isClearable
              options={optionsCorretores}
              value={corretorSelecionado}
              onChange={option => {
                setCorretorSelecionado(option);
                setLinkGerado('');
              }}
              placeholder="Selecione um corretor..."
              noOptionsMessage={() => 'Nenhum corretor encontrado'}
              styles={customStyles}
              components={{ DropdownIndicator }}
            />
          </div>
        )}
        {!linkGerado && (
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={handleGerar}
              disabled={!empreendimentoSelecionado || loading}
              style={{ background: '#419AEF', borderColor: '#419AEF' }}
            >
              {loading ? <Spinner animation="border" size="sm" /> : 'Gerar Link'}
            </Button>
          </div>
        )}
        {linkGerado && (
          <div className="mt-3">
            <div
              className="d-flex align-items-center p-2"
              style={{ background: '#f5f5f5', borderRadius: '4px', wordBreak: 'break-all' }}
            >
              <span className="flex-grow-1" style={{ fontSize: '0.9rem' }}>{linkGerado}</span>
              <Button
                variant="link"
                size="sm"
                onClick={handleCopiar}
                title="Copiar"
                style={{ padding: '0 4px', marginLeft: '8px' }}
              >
                <FaCopy size={16} />
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = state => ({
  corretores: state.corretor.listaCorretores,
});

export default connect(mapStateToProps)(ModalLinkCadastro);
